export const NULL = null;
export const UNDEFINED = undefined;
